import { Navigate } from "react-router-dom";
import useLangStore from "@/hooks/useLangStore";
import ChooseLangScreen from "@/UI/screens/ChooseLangScreen";

export default function ChooseLangRoute() {
    const { lang } = useLangStore();
    if (lang) return <Navigate to="/login" replace />;
    return <ChooseLangScreen />;
}
